import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";


const dropdownItems = {

  Crop: [
    "MAIZE",
    "Apples",
    "Avocado",
    "Bananas",
    "Beans",
    "Cabbages",
    "Kale",
    "Mangoes",
    "Onions",
    "Passion Fruits",
    "Papaya",
    "Potatoes",
    "Strawberries",
    "Tomatoes",
    "Watermelon",
  ],
  Livestock: [
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
  ],
  
};



const Dropdown = ({ label, items, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);


  return (
<div className="flex flex-col w-full relative ">
  {/* Label */}
  <label className="md:text-[24px] font-bold text-[6px] text-black mb-1 md:mb-1">
    {label}
  </label>

  {/* Button + Icon Container */}
  <div className="flex relative z-20 w-fit">
    {/* Dropdown Button */}
    <button
      onClick={() => setIsOpen((prev) => !prev)}
      className="xl:w-[250px] lg:w-[140px] md:w-[55px] w-[60px] h-[15px] md:h-[40px] bg-[#2E453D] text-white font-bold flex justify-between items-center md:px-1 px-2 rounded-l-[10px]"
    >
      <span className="md:text-[14px] md:px-4 text-[4px] md:mt-0 mt-[2px]">{selected}</span>
    </button>

    {/* Icon Box */}
    <div
      className="w-[20px] h-[15px] md:h-[40px] md:w-[45px] bg-[#152C24] text-white flex justify-center items-center md:rounded-tr-[10px]  md:rounded-br-[10px]   rounded-[5px] -ml-2 z-30 cursor-pointer"
      onClick={() => setIsOpen((prev) => !prev)}
    >
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745495994/Expand_down_6_vwg7e4.png"
        alt="expand"
        className="w-3 h-3 md:w-6 md:h-7"
      />
    </div>
  </div>

  {/* Dropdown List */}
  {/* Dropdown List */}
  <AnimatePresence>
    {isOpen && (
      <motion.ul
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        className="absolute top-full mt-1 left-0 z-50 md:w-[180px] w-[70px] bg-white/90 rounded-lg shadow-lg"
      >
        {items.map((item, index) => (
          <li
            key={index}
            onClick={() => {
              setSelected(item);
              setIsOpen(false);
            }}
            className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[6px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
          >
            <span className="text-black">{item}</span>
          </li>
        ))}
      </motion.ul>
    )}
  </AnimatePresence>

  <p className="md:text-[14px] text-[6px] font-normal mt-1 text-black">
  {type === "Crop"
    ? "Select type of crop"
    : type === "Livestock"
    ? "Select type of livestock"
    : `Select ${label}`}
</p>


</div>


  
  );
};

const Resources = () => {
  const dropdownItems = {
    CROP: ["Wheat", "Maize", "Rice"],
    LivestockS: ["Cattle", "Sheep"],
  };

  const seedsData = [
    {
      title: "Maize",
      brand: "FDP Agro",
      category: "Horticulture",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745445507/image_28_kdizs6.png",
      link: "/ResourcesPage1",
    },
    {
      title: "Wheat",
      brand: "AgriGrow",
      category: "Cereal",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745445507/image_28_kdizs6.png",
      link: "/ResourcesPage1",
    },
    {
      title: "Rice",
      brand: "GreenFarm",
      category: "Crop",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745445507/image_28_kdizs6.png",
      link: "/ResourcesPage1",
    },
  ];

  return (
    <div className="bg-white px-4 md:px-24 py-6 md:py-12">
      <div>
        <h2 className="text-[10px] md:text-[36px] font-bold text-[#FDBD26]">
          Resources
        </h2>
        <div className="flex md:flex-row justify-between md:-mt-6 items-start md:items-center">
          <h2 className="text-[10px] md:text-[36px] font-bold text-black">
            Farming Inputs
          </h2>
          <div className="flex md:gap-2 gap-[3px]">
            {Object.keys(dropdownItems).map((type) => {
              const customLabels = {
                CROP: "Crop Report",
                LivestockS: "Livestock Report",
              };

              const displayLabel = customLabels[type] || type;

              return (
                <div key={type} className="w-full sm:w-auto">
                  <Dropdown label={displayLabel} items={dropdownItems[type]} type={type} />
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* RUN REPORT Button */}
      <div className="flex justify-between items-start md:mt-8 mt-3">
        <div></div>
        <div className="flex items-center ml-auto md:pr-0">
          <p className="md:text-[16px] text-[5px] bg-[#2E453D] text-white px-2 md:px-4 md:w-[250px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
            RUN REPORT
          </p>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
            alt="Expand"
            className="w-[20px] h-[5px] md:h-[42px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#FFBD26] px-2 md:py-2"
          />
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
            alt="Expand"
            className="w-[20px] h-[13px] md:hidden flex py-[1px] md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#FFBD26] md:px-2 px-[2px] md:py-1"
          />
        </div>
      </div>

      {/* Farming Sections */}
      <div className="md:mt-4 mt-6">
        {["Seeds", "Fertilizer", "Pesticide", "Herbicides", "Equipments"].map(
          (section, idx) => (
            <div className="md:mb-12 mb-2 md:mt-0" key={idx}>
              <div className="flex justify-between items-center md:mb-0 mb-1">
                <h2 className="text-[10px] md:text-[40px] font-bold">
                  {section}
                </h2>
                <button className="text-[8px] md:text-[20px] flex items-center space-x-2 md:mb-0">
                  <span>View more</span>
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745513012/Expand_down_8_nldzk1.png"
                    alt="Expand"
                    className="w-2 h-2 md:flex hidden md:w-9 md:h-8"
                  />
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745511779/Expand_down_7_y6mkyp.png"
                    alt="Expand"
                    className="w-3 h-3 md:hidden flex md:w-6 md:h-6"
                  />
                </button>
              </div>
              <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 md:gap-6 gap-2">
                {seedsData.map((item, index) => (
                  <Link to={item.link} key={`${section}-${index}`}>
                    <div className="bg-[#F3F5F5] rounded-md overflow-hidden hover:shadow-lg transition">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-14 md:h-56 object-cover"
                      />
                      <div className="md:p-4 p-1">
                        <p className="text-[8px] md:text-[24px] md:mt-0 mt-1">
                          {item.title}{" "}
                          <span className="font-semibold">{item.brand}</span>
                        </p>
                        <p className="text-[6px] md:text-[24px] text-black">
                          {item.category}
                        </p>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Resources;
